export const FreeRentAssessmentValidationScheme = {
    fullName: [
        { rule: "required", message: "Full Name is required" },
        { rule: "fullName", message: "Please enter full name" },
    ],
    phone_number_free: [
        { rule: "required", message: "Phone number is required" },
        { rule: "phone", length: 10, message: "Phone number must be of 10 digits" },
    ]
}